import React from "react";
import PropTypes from "prop-types";
import img_cloud from "@icoach/assets/img/cloud.png";
import { Box, Button, Typography } from "@curves/ui-base";
import clsx from "clsx";

/**
 * UploadFeedbackBox 上傳結果回饋顯示元件
 *
 * @param {UploadFeedbackBoxProps} props
 */
/**
 * @typedef {Object} UploadFeedbackBoxProps
 * @property {string} [className] - 額外樣式類別
 * @property {boolean} isShow - 是否顯示此元件
 * @property {boolean} [isError=false] - 是否為錯誤狀態
 * @property {number} [totalAmount=0] - 上傳總筆數
 * @property {number} [successAmount=0] - 成功筆數
 * @property {number} [failureAmount=0] - 失敗筆數
 * @property {string} [failureDownloadPath] - 錯誤筆數下載連結
 * @property {function} [onDownload] - 點擊下載按鈕時觸發
 * @property {function} [onConfirm] - 點擊完成按鈕時觸發
 */
const UploadFeedbackBox = props => {
	const { className, isShow, isError = false, totalAmount = 0, successAmount = 0, failureAmount = 0, failureDownloadPath: link, onDownload, onConfirm } = props;

	let titleClassName = "is-success";
	let titleText = "上傳成功";
	if (isError) {
		titleClassName = "is-error";
		titleText = "上傳失敗";
	}

	if (!isShow) return null;

	return (
		<Box className={clsx("upload-feedback-box text-center", className)}>
			<Typography className={clsx("upload-feedback-box-title", titleClassName)} variant={"h6"}>
				{titleText}
			</Typography>
			<Box className="upload-feedback-box-wrap">
				<Box component="img" className="upload-feedback-box-img" src={img_cloud} alt="" />
				<Typography>總筆數： {totalAmount}</Typography>
				<Typography className={clsx("desc", { "is-success": !isError })}>正確數： {successAmount}</Typography>
				<Typography className={clsx("desc mb-3", { "is-error": isError })}>錯誤數： {failureAmount}</Typography>
			</Box>
			{isError ? (
				link && (
					<React.Fragment>
						<Typography variant="body2">下載並檢視錯誤欄位，修正後請重新上傳</Typography>
						<Button variant="contained" href={link} onClick={onDownload} download>
							下載
						</Button>
					</React.Fragment>
				)
			) : (
				<Button variant="contained" onClick={onConfirm}>
					完成
				</Button>
			)}
		</Box>
	);
};

export default UploadFeedbackBox;

UploadFeedbackBox.propTypes = {
	className: PropTypes.string,
	isShow: PropTypes.bool.isRequired,
	isError: PropTypes.bool,
	totalAmount: PropTypes.number,
	successAmount: PropTypes.number,
	failureAmount: PropTypes.number,
	failureDownloadPath: PropTypes.string,
	onDownload: PropTypes.func,
	onConfirm: PropTypes.func,
};
